import { response } from "express";
import ApiError, { ApiErrorCode } from "../../error/api-error"

export const defaultErrorMessages: ErrorMessages = {
	methodNotAllowed: "La méthode employée n'est pas autorisée.",
	notFound: "La ressource n'a pas été trouvée.",
	unauthorized: "Vous n'avez pas l'autorisation requise.",
	unprocessableEntity: "Le champ ne peut pas être modifié."
}

export function genericFetch<TResult>(
	input: string | Request,
	init: RequestInit,
	errorMessages: ErrorMessages = defaultErrorMessages
): Promise<TResult> {
	return fetch(input, init)
	.then(response => {
			switch (response.status) {
				case 200:
					return response.json().then(value => value as TResult)
				case 204:
					return {} as TResult;
				case 401:
					throw new ApiError(ApiErrorCode.Unauthorized, errorMessages.unauthorized)
				case 404:
					throw new ApiError(ApiErrorCode.NotFound, errorMessages.notFound)
				case 405:
					throw new ApiError(ApiErrorCode.MethodNotAllowed, errorMessages.methodNotAllowed)
				case 422:
					throw new ApiError(ApiErrorCode.UnprocessableEntity, errorMessages.unprocessableEntity)
				default:
					return
			}
		})
}

export interface ErrorMessages {
	methodNotAllowed: string
	notFound: string
	unauthorized: string
	unprocessableEntity: string
}



// WEBPACK FOOTER //
// ./src/service/sfp/common-service.ts